import { createAction, props } from '@ngrx/store';

import { SignUpDetails } from '@lockton-apps/shared/interfaces';

export enum CreateAccountActionTypes {
  FormSubmitted = '[Create Account] Form Submitted',
}

export const CreateAccountActions = {
  formSubmitted: createAction(
    CreateAccountActionTypes.FormSubmitted,
    props<{ signUpDetails: SignUpDetails }>()
  ),
};
